import {
  Directive,
  Input,
  ElementRef,
  ViewContainerRef,
  OnDestroy
} from '@angular/core';

import { DialogRef } from '../models/dialog-ref';
import { vcRefStore } from '../models/vc-ref-store';
import { Overlay } from './overlay.service';
/**
 * A directive use to signal the overlay that the host of this directive
 * is a dialog boundary, i.e: over click outside of the element should close the modal
 * (if non blocking)
 */
export class OverlayDialogBoundary {
/**
 * @param {?} el
 * @param {?} dialogRef
 */
constructor(el: ElementRef, dialogRef: DialogRef<any>) {
    if (dialogRef && el.nativeElement) {
      dialogRef.overlayRef.instance.setClickBoundary(el.nativeElement);
    }
  }

static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[overlayDialogBoundary]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: DialogRef, },
];
}

function OverlayDialogBoundary_tsickle_Closure_declarations() {
/** @type {?} */
OverlayDialogBoundary.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OverlayDialogBoundary.ctorParameters;
}

export class OverlayTarget implements OnDestroy {
/**
 * @param {?} value
 * @return {?}
 */
set targetKey(value: string) {
    this._targetKey = value;
    if (value) {
      vcRefStore.setVCRef(value, this.vcRef);
    }
  }
private _targetKey: string;
/**
 * @param {?} vcRef
 */
constructor(private vcRef: ViewContainerRef) {}
/**
 * @return {?}
 */
ngOnDestroy() {
    if (this._targetKey) {
      vcRefStore.delVCRef(this._targetKey, this.vcRef);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[overlayTarget]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ViewContainerRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'targetKey': [{ type: Input, args: ['overlayTarget', ] },],
};
}

function OverlayTarget_tsickle_Closure_declarations() {
/** @type {?} */
OverlayTarget.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OverlayTarget.ctorParameters;
/** @type {?} */
OverlayTarget.propDecorators;
/** @type {?} */
OverlayTarget.prototype._targetKey;
/** @type {?} */
OverlayTarget.prototype.vcRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
